import { InvokeCallback } from "xstate";
import { withToken } from "@rentablo/api";
import { listAndSearchAllAccounts } from "@rentablo/api/apiv1";
import {
  NetfondsConsentContext,
  NetfondsConsentEvent,
} from "../netfondsConsentSM";

export const reloadAccounts =
  (
    context: NetfondsConsentContext
  ): InvokeCallback<NetfondsConsentEvent, NetfondsConsentEvent> =>
  (callback) => {
    const timeout = import.meta.env.NETFONDS_CONSENT_RELOAD_CHECK_INTERVAL
      ? parseInt(import.meta.env.NETFONDS_CONSENT_RELOAD_CHECK_INTERVAL)
      : 3000;

    if (
      context.externalDepotIds.length <=
      context.depots.filter((depot) => depot.lastSyncDate).length
    ) {
      callback({
        type: "FINISHED",
      });
      return;
    }

    setTimeout(() => {
      const getAccounts = withToken(listAndSearchAllAccounts);
      getAccounts({
        type: ["01_depot"],
        bankConnectionType: ["NETFONDS"],
      })
        .then(({ accounts }) => {
          callback({
            type: "IMPORT_DATA",
            depots: accounts,
          });
        })
        .catch((error) => {
          callback({
            type: "SOMETHING_WRONG",
            error: error,
          });
        });
    }, timeout);
  };
